// BST-10541 «Аспекты 2.0» — V1 benchmarks for the strong/weak table view.
// Tonality index scale is [-100..+100]. Kept in one place so they can be tuned
// after review on real data.
export const aspectStrongThreshold = 50;
export const aspectWeakThreshold = -10;
export const aspectMinTotalReviews = 10;
